import InfoForm from "./info-form";

const formSteps = [
  {
    name: "Retirement Set Info",
    description: "Information about service orders with meters to be retired",
    accessor: "info",
    FormComponent: InfoForm,
  },
]

export default formSteps;
